import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { styled } from "@mui/material";
import { AnimatePresence, HTMLMotionProps, motion } from "motion/react";

interface CharactersLimitProps extends HTMLMotionProps<"div"> {
  text: string;
  minLength: number;
  maxLength?: number;
}

const CharactersLimitWrapper = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  marginTop: "8px",
  marginBottom: "8px",
  fontSize: 16,
  minHeight: "1.5em", // prevents layout shift when message appears and disappears
  position: "relative",
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 12,
  },
}));

const CharactersLimit = ({
  text,
  minLength,
  maxLength,
  ...props
}: CharactersLimitProps) => {
  const inputLength = (text || "").trim().length;
  const minimumLength = (minLength || 0) >= 0 ? minLength : 0;
  const maximumLength = maxLength;
  let message = "";
  if (inputLength < minimumLength) {
    message = `Must be at least ${minimumLength} characters`;
  } else if (maximumLength && inputLength > maximumLength) {
    message = `Exceeded the ${maximumLength} characters limit`;
  }
  return (
    <CharactersLimitWrapper {...props}>
      <AnimatePresence mode="wait">
        {message && (
          <motion.p
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            style={{
              margin: 0,
              color: "#7E8FA8",
            }}
          >
            {message}
          </motion.p>
        )}
      </AnimatePresence>
    </CharactersLimitWrapper>
  );
};

export default CharactersLimit;
